import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import withStyles from '@material-ui/core/styles/withStyles';
import styles from './styles';

const Spinner = ({ size, position, classes, ...props }) => {
  const styles = {
    position: position,
    overflow: 'hidden',
    margin: 'auto',
    height: size,
    width: size,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 999999,
  };

  return (
    <div style={styles}>
      <CircularProgress {...props} className={classes.spinner} size={size} />
    </div>
  );
};

Spinner.propTypes = {
  size: PropTypes.number,
  position: PropTypes.string,
};

Spinner.defaultProps = {
  size: 80,
  position: 'absolute',
};

export default withStyles(styles)(Spinner);
